// AuthContext.js
import React, { createContext, useState, useEffect, useMemo } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [loggedIn, setLoggedIn] = useState(() => 
        JSON.parse(localStorage.getItem('loggedIn') || 'false')
    );
    const [userName, setUserName] = useState(() => 
        localStorage.getItem('userName') || ''
    );
    const [adminUser, setAdminUser] = useState(() => 
        JSON.parse(localStorage.getItem('adminUser') || 'false')
    );
    const [adminAuthLevel, setAdminAuthLevel] = useState(() => 
        JSON.parse(localStorage.getItem('adminAuth') || null)
    );
    const [isFirstTime, setIsFirstTime] = useState(() => 
        JSON.parse(localStorage.getItem('firstTime') || 'false')
    );
    const [loggedUser, setLoggedUser] = useState(() => 
        localStorage.getItem('loggedUser') || ''
    );
    const [viewedUser, setViewedUser] = useState(() =>
        JSON.parse(localStorage.getItem('viewedUser')) || null );
    
    const [isLoading, setIsLoading] = useState(true);

    // Sync state back to localStorage
    useEffect(() => {
        localStorage.setItem('loggedIn', JSON.stringify(loggedIn));
    }, [loggedIn]);

    useEffect(() => {
        localStorage.setItem('userName', userName);
    }, [userName]);

    useEffect(() => {
        localStorage.setItem('adminUser', JSON.stringify(adminUser));
    }, [adminUser]);

    useEffect(() => {
        localStorage.setItem('adminAuth', JSON.stringify(adminAuthLevel));
    }, [adminUser]);

    useEffect(() => {
        localStorage.setItem('firstTime', JSON.stringify(isFirstTime));
    }, [isFirstTime]);

    useEffect(() => {
        localStorage.setItem('loggedUser', loggedUser);
    }, [loggedUser]);

    useEffect(() => {
        localStorage.setItem('viewedUser', JSON.stringify(viewedUser));
    }, [viewedUser]);

    // Memoize context value to prevent unnecessary re-renders and stale closures
    const contextValue = useMemo(() => ({
        loggedIn,
        setLoggedIn,
        userName,
        setUserName,
        adminUser,
        setAdminUser,
        adminAuthLevel,
        setAdminAuthLevel,
        viewedUser,
        setViewedUser,
        isLoading,
        setIsLoading,
        isFirstTime,
        setIsFirstTime,
        loggedUser,
        setLoggedUser,
    }), [
        loggedIn, userName, adminUser, adminAuthLevel, viewedUser, isLoading,
        isFirstTime, loggedUser
    ]);

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    );
};